// Local helper method to duplicate a field
const duplicateField = (field, groupId, fieldRepository, context) => {
    const duplicatedField = fieldRepository.create(context);
    const group = store.form.groups.get(groupId);
    const fieldKeysBlocklist = ['id', 'groupId', 'group', 'position'];

    duplicatedField.position = group.fields.length + 1;

    Object.keys(field).forEach((key) => {
        if (fieldKeysBlocklist.includes(key)) {
            return;
        }

        duplicatedField[key] = field[key];
    });

    return duplicatedField;
};

// Local helper method to sanitize quantities
const sanitizePositions = (fieldCollection, movedPosition) => {
    fieldCollection.forEach((field) => {
        if (field.position < movedPosition) {
            return;
        }

        field.position -= 1;
    });
};

Shopware.Store.register('swCmsDetailCurrentCustomForm', {
    state: () => ({
        form: null,
        activeItem: null,
    }),
    actions: {
        getTemplate(templateName, formRepository, groupRepository, fieldRepository) {
            const formTemplate = formRepository.create(Shopware.Context.api);
            formTemplate.isTemplate = true;
            formTemplate.technicalName = templateName;
            formTemplate.title = this.form.title;
            formTemplate.successMessage = this.form.successMessage;
            formTemplate.receivers = this.form.receivers;
            formTemplate.mailTemplateId = this.form.mailTemplateId;

            this.form.groups.forEach((group) => {
                const g = groupRepository.create(Shopware.Context.api);
                g.technicalName = group.technicalName;
                g.title = group.title;
                g.position = group.position;

                group.fields.forEach((field) => {
                    const f = fieldRepository.create(Shopware.Context.api);
                    f.position = field.position;
                    f.width = field.width;
                    f.type = field.type;
                    f.technicalName = field.technicalName;
                    f.required = field.required;
                    f.label = field.label;
                    f.placeholder = field.placeholder;
                    f.errorMessage = field.errorMessage;
                    f.config = field.config;

                    g.fields.add(f);
                });

                formTemplate.groups.add(g);
            });

            return formTemplate;
        },
        setItemPosition(itemId, to, from, callbackUp, callbackDown) {
            let steps = 0;

            if (to > from) {
                steps = to - from;
            } else {
                steps = from - to;
            }

            for (let i = 0; i < steps; i += 1) {
                if (to > from) {
                    this.moveItem(itemId, callbackDown);
                } else {
                    this.moveItem(itemId, callbackUp);
                }
            }
        },
        moveFieldToGroup(fieldId, fromGroupId, toGroupId, fieldRepository, context) {
            const originalFields = this.form.groups.get(fromGroupId).fields;
            const originalField = originalFields.get(fieldId);
            const toggleActiveOnFieldMove = originalField.id === this.activeItem.id;

            const fields = this.form.groups.get(toGroupId).fields;
            const field = duplicateField(originalField, fromGroupId, fieldRepository, context);
            field.position = fields.length + 1;
            fields.add(field);
            originalFields.remove(fieldId);
            sanitizePositions(originalFields, originalField.position);

            if (toggleActiveOnFieldMove) {
                this.activeItem = fields.last();
            }
        },
        setFormProperty(property, value) {
            this.form[property] = value;
        },
        setActiveItem(activeItem) {
            this.activeItem = activeItem;
        },
        setFieldProperty(fieldId, property, value) {
            const group = this.form.groups.find(formGroup => formGroup.fields.get(fieldId));
            group.fields.get(fieldId)[property] = value;
        },
        setFieldConfigProperty(fieldId, property, value) {
            const group = this.form.groups.find(formGroup => formGroup.fields.get(fieldId));
            const field = group.fields.get(fieldId);

            field.config = {
                ...(field.translated?.config ?? {}),
                [property]: value,
            };

            field.translated = { ...field.translated };
            field.translated.config = { ...field.config };
        },
        setFieldType(fieldId, type) {
            const group = this.form.groups.find(formGroup => formGroup.fields.get(fieldId));
            const field = this.form.groups.get(group.id).fields.get(fieldId);
            field.config = {};
            field.type = type;

            switch (type) {
                case 'number':
                    field.config = {
                        min: null,
                        max: null,
                        step: 1,
                    };
                    break;
                case 'select':
                    field.config = {
                        entity: null
                    };
                    break;
                case 'textarea':
                    field.config = {
                        scalable: true,
                        rows: 5
                    };
                    break;
                case 'checkbox':
                    field.config = {
                        default: false
                    };
                    break;
                case 'text':
                case 'email':
                default:
                    break;
            }
        },
        changeFieldSelectConfig(fieldId, mode) {
            const group = this.form.groups.find(formGroup => formGroup.fields.get(fieldId));
            const field = this.form.groups.get(group.id).fields.get(fieldId);

            if (!field?.translated?.config) {
                return;
            }

            field.config = {};

            if (mode === 'entity') {
                field.config = {
                    options: undefined,
                };

                return;
            }

            field.config.entity = undefined;
        },
        setGroupProperty(groupId, property, value) {
            const group = this.form.groups.get(groupId);
            group[property] = value;
        },
        addField(groupId, repository, context, prefix) {
            const group = this.form.groups.get(groupId);
            const field = repository.create(context);
            const overallFieldCount = this.form.groups.reduce((acc, g) => {
                acc += g.fields.length;

                return acc;
            }, 0);

            field.id = Shopware.Utils.createId();
            field.technicalName = `${prefix}${overallFieldCount + 1}`;
            field.position = group.fields.length + 1;
            field.type = 'text';
            field.width = 12;
            field.config = {};

            group.fields.add(field);
            this.activeItem = field;
        },
        addGroup(repository, prefix, context) {
            const group = repository.create(context);

            group.technicalName = `${prefix}${this.form.groups.length + 1}`;
            group.position = this.form.groups.length + 1;
            this.form.groups.add(group);
            this.activeItem = group.fields.first();
        },
        moveItem(itemId, callback) {
            let group = this.form.groups.find(formGroup => formGroup.id === itemId);

            // itemId is not a group find the group containing a field with the id itemId
            if (!group) {
                group = this.form.groups.find(formGroup => formGroup.fields.get(itemId));
                callback(group.fields, group.fields.get(itemId));
                return;
            }

            callback(this.form.groups, this.form.groups.get(itemId));
        },
        duplicateGroup(groupId, fieldRepository, context) {
            const originalGroup = this.form.groups.get(groupId);

            const duplicateCollection = new Shopware.Data.EntityCollection(
                `/swag-cms-extensions-form-group/${this.form.groups.last().id}/fields`,
                originalGroup.fields.entity,
                originalGroup.fields.context,
                originalGroup.fields.criteria,
            );

            originalGroup.fields.forEach((field) => {
                duplicateCollection.add(duplicateField(field, groupId, fieldRepository, context));
            });

            this.form.groups.last().fields = duplicateCollection;
        },
        deleteGroup(groupId) {
            const groupToDelete = this.form.groups.get(groupId);

            if (this.activeItem.id === groupId) {
                const nextGroup = this.form.groups.getAt(groupToDelete.position);
                if (nextGroup) {
                    this.activeItem = nextGroup;
                } else {
                    this.activeItem = this.form.groups.getAt(groupToDelete.position - 2);
                }
            }

            sanitizePositions(this.form.groups, groupToDelete.position);
            this.form.groups.remove(groupId);
        },
        deleteField(fieldId, groupId) {
            const group = this.form.groups.get(groupId);
            const fieldToRemove = group.fields.get(fieldId);

            sanitizePositions(group.fields, fieldToRemove.position);
            group.fields.remove(fieldId);
            this.activeItem = group;
        },
        duplicateField(groupId, fieldId, repository, context) {
            const group = this.form.groups.get(groupId);
            group.fields.add(duplicateField(group.fields.get(fieldId), groupId, repository, context));
        },
    },

});
